/*
 * @Author: 张天昊
 * @Date: 2024-09-06 10:58:48
 * @LastEditTime: 2024-09-10 16:17:11
 * @LastEditors: 张天昊
 * @Description:
 * @FilePath: /Mobile/src/components/FilePreviewer/fileType.js
 */
export const BusiFileTypes = {
  图片: 1,
  视频: 2,
  音频: 3,
  其他: 4,
}
export const FileTypes = {
  文档: 'pdf',
  文稿: 'doc,docx',
  表格: 'xls,xlsx',
  文本: 'txt',
  压缩包: 'zip,rar',
  音视频: 'mp3,mp4,mov,wav,mkv,m4a,m4v',
  音频: 'mp3,wav,m4a',
  视频: 'mp4,mov,mkv,m4v',
  图片: 'jpg,jpeg,png,gif,webp'
};
